import { BaseRequestModel } from '../../../base/base.request.model';

export class EntitlementRequestModel extends BaseRequestModel {
  assetID?: string;
  returnTVOD!: string;
  returnPrice?: string;
  contactID!: string;
  returnUpgradableFlag!: boolean;
  returnProductAttributes!: boolean;
}
